/** @deprecated Vista plana legacy — ver `../legacy/README.md`. */
import React, { useCallback, useMemo } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Container, Row, Col, Card, CardBody, CardHeader, Alert } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import GuidesFlatGrid from './GuidesFlatGrid';
import { getGuidesFlat } from '../../../slices/guide/thunk';
import { applyGuideGrouping } from './guidesFlatGrouping';
import { normalizeGuidesFlatQuery } from './guidesFlatQueryNormalize';
import { residue_config } from '../../../config';

const SCOPE_TO_GUIDE_RESIDUE_TYPE_ID = {
	peligrosos: residue_config.REACT_APP_RESIDUE_TYPE_PELIGROSOS,
	'no-peligrosos': residue_config.REACT_APP_RESIDUE_TYPE_NO_PELIGROSOS,
};

const SCOPE_LABEL = {
	peligrosos: 'Residuos peligrosos',
	'no-peligrosos': 'Residuos no peligrosos',
};

/** Vista :scope (peligrosos | no-peligrosos). Filtros solo por columnas (OData remoto). */
const GuidesFlatView = () => {
	const { scope } = useParams();

	const lockedGuideResidueTypeId = SCOPE_TO_GUIDE_RESIDUE_TYPE_ID[scope] ?? null;

	const total = useSelector(s => s.Guides.guidesFlatTotal);
	const error = useSelector(s => s.Guides.error);
	const isGuidesFlatError = useSelector(s => s.Guides.isGuidesFlatError);

	if (!scope || !SCOPE_TO_GUIDE_RESIDUE_TYPE_ID[scope]) {
		return <Navigate to="/residue/guides-flat/peligrosos" replace />;
	}

	const getDataFunc = useCallback(
		query => async innerDispatch => {
			const normalized = normalizeGuidesFlatQuery(query);
			const merged = {
				guide_residue_type_id: lockedGuideResidueTypeId,
				...normalized,
			};
			const res = await innerDispatch(getGuidesFlat(merged)).unwrap();
			return {
				data: applyGuideGrouping(res.data),
				meta: res.meta,
			};
		},
		[lockedGuideResidueTypeId],
	);

	const scopeSubtitle = SCOPE_LABEL[scope];
	const pageTitle = `Guías por ítems — ${scopeSubtitle}`;

	const breadcrumbItems = useMemo(
		() => [
			{ title: 'Ambiente', link: '#' },
			{ title: 'Guías', link: '/residue/guides' },
			{ title: 'Guías por ítems', link: '#' },
			{ title: scopeSubtitle, link: '#' },
		],
		[scopeSubtitle],
	);

	return (
		<React.Fragment>
			<div className="page-content">
				<Container fluid>
					<BreadCrumb title={pageTitle} breadcrumbItems={breadcrumbItems} />

					<Row>
						<Col lg={12}>
							<Card>
								<CardHeader className="d-flex justify-content-between align-items-center">
									<h5 className="card-title mb-0">
										Guías desnormalizadas ({scopeSubtitle})
									</h5>
									<small className="text-muted">{total} ítems encontrados</small>
								</CardHeader>
								<CardBody>
									{isGuidesFlatError && (
										<Alert color="danger" className="mb-3">
											<i className="ri-error-warning-line me-2" />
											Error al cargar los datos: {error}
										</Alert>
									)}

									<GuidesFlatGrid key={scope} getDataFunc={getDataFunc} />
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default GuidesFlatView;
